import { render, staticRenderFns } from "./ModalEditarProtocolosVinculados.vue?vue&type=template&id=36a334a5&lang=pug"
import script from "./ModalEditarProtocolosVinculados.vue?vue&type=script&lang=js"
export * from "./ModalEditarProtocolosVinculados.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarProtocolosVinculados.vue?vue&type=style&index=0&id=36a334a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports